import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { sampleYaml } from '../data/pipelineData';

export const YamlModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        data-testid="yaml-export-modal"
        className="max-w-3xl max-h-[80vh] overflow-hidden"
        aria-describedby="yaml-modal-description"
      >
        <DialogHeader>
          <DialogTitle className="font-sans text-xl font-semibold text-[#1A3A5C] flex items-center gap-2">
            <span className="text-[#378ADD]">.</span>gitlab-ci.yml
          </DialogTitle>
          <DialogDescription id="yaml-modal-description" className="sr-only">
            Sample GitLab CI/CD pipeline configuration
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4 overflow-auto max-h-[60vh] rounded-lg bg-[#1A3A5C] p-4">
          <pre className="font-mono text-sm text-[#E2E8F0] whitespace-pre overflow-x-auto leading-relaxed">
            {sampleYaml}
          </pre>
        </div>
        <div className="mt-4 text-xs text-[#1A3A5C]/60 text-center">
          Sample pipeline configuration for your DevOps workflow
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default YamlModal;
